import { Link } from 'react-router-dom';

const Missing = () => {
  return (
    <article style={{ padding: '100px' }}>
      <h1>Oops!</h1>
      <p>Halaman tidak ditemukan!</p>
      <div className="flexGrow">
        <Link to="/">Kembali Ke Beranda</Link>
      </div>
    </article>
  );
};

export default Missing;
